"use client";

import { ArrowUpRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const fallbackProjects = [{
  id: "f1",
  title: "National Retail Growth",
  category: "National SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/national_seo_growth.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/national_seo_growth.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/national_seo_growth.webp-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f2",
  title: "Global SaaS Expansion",
  category: "International SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_saas_expansion.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_saas_expansion.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_saas_expansion.png-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f3",
  title: "Local Service Dominance",
  category: "Local SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_service_dominance.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_service_dominance.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_service_dominance.png-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f4",
  title: "B2B Lead Generation",
  category: "B2B SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/b2b_lead_generation.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/b2b_lead_generation.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/b2b_lead_generation.png-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f5",
  title: "Ecommerce Revenue Lift",
  category: "Ecommerce SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ecommerce_revenue_lift.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ecommerce_revenue_lift.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ecommerce_revenue_lift.png-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f6",
  title: "Technical Audit Recovery",
  category: "Technical SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/technical_audit_recovery.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/technical_audit_recovery.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/technical_audit_recovery.png-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f7",
  title: "AI Search Visibility",
  category: "AI Search",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ai_search_visibility.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ai_search_visibility.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ai_search_visibility.webp-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f8",
  title: "Full Site Migration",
  category: "Technical SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/full_site_migration.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/full_site_migration.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/full_site_migration.png-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f9",
  title: "Content Strategy Scale",
  category: "National SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/content_strategy_scale.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/content_strategy_scale.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/content_strategy_scale.png-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f10",
  title: "Market Share Capture",
  category: "National SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/market_share_capture.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/market_share_capture.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/market_share_capture.png-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f11",
  title: "Brand Authority Build",
  category: "B2B SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/brand_authority_build.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/brand_authority_build.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/brand_authority_build.png-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f12",
  title: "Conversion Rate Audit",
  category: "SEO Audits",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/conversion_rate_audit.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/conversion_rate_audit.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/conversion_rate_audit.png-wvc-sizes",
  orientation: "horizontal"
}];
const spanClasses = ["md:col-span-5 aspect-[4/5]", "md:col-start-7 md:col-span-6 aspect-[16/9]", "md:col-span-7 aspect-[16/9]", "md:col-start-9 md:col-span-4 aspect-[4/5]", "md:col-span-5 aspect-[4/5]", "md:col-start-7 md:col-span-6 aspect-[16/9]", "md:col-span-7 aspect-[16/9]", "md:col-start-9 md:col-span-4 aspect-[4/5]", "md:col-span-5 aspect-[4/5]", "md:col-start-7 md:col-span-6 aspect-[16/9]", "md:col-span-7 aspect-[16/9]", "md:col-start-9 md:col-span-4 aspect-[4/5]"];
function ProjectCard({
  title,
  category,
  image,
  srcset,
  sizes,
  link,
  spanClass,
  index
}: {
  title: string;
  category: string;
  image: string;
  srcset?: string;
  sizes?: string;
  link: string;
  spanClass: string;
  index: number;
}) {
  const CardWrapper: React.ElementType = link && link !== "#" ? Link : "div";
  const wrapperProps = link && link !== "#" ? {
    to: link
  } : {};
  return <CardWrapper data-index={index} {...wrapperProps} className={`group relative block overflow-hidden rounded-lg bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-4 focus-visible:ring-offset-background ${spanClass}`}>
      <img src={image} data-wvc-srcset={srcset} data-wvc-sizes={sizes} alt={title} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover brightness-[0.85] transition-transform duration-500 ease-out group-hover:scale-[1.03] group-focus-visible:scale-[1.03]" />
      <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-background/90 via-background/30 to-transparent" />

      <div className="absolute inset-0 flex flex-col justify-between p-6 md:p-10">
        <div className="flex justify-start">
          <Badge variant="outline" className="rounded-sm border-primary/30 bg-background/50 px-3.5 py-1 text-[13px] uppercase tracking-[0.18em] text-primary backdrop-blur-sm">
            {category}
          </Badge>
        </div>

        <div className="relative">
          <h3 className="font-serif text-xl leading-[1.05] tracking-tight text-foreground sm:text-2xl">
            <span className="relative inline-block">
              {title}
              <span aria-hidden="true" className="absolute -bottom-1 left-0 h-[2px] w-0 origin-left rounded-full bg-accent transition-all duration-500 ease-out group-hover:w-full group-focus-visible:w-full" />
            </span>
          </h3>

          <div className="pointer-events-none absolute right-0 bottom-0 opacity-100 translate-y-0 md:opacity-0 md:translate-y-2 md:transition-all md:duration-300 md:ease-out md:group-hover:opacity-100 md:group-hover:translate-y-0 md:group-focus-visible:opacity-100 md:group-focus-visible:translate-y-0">
            <Button asChild={false} size="sm" className="pointer-events-auto h-auto rounded-sm bg-primary px-5 py-2.5 text-xs font-medium tracking-wide text-primary-foreground hover:bg-primary/90">
              <span className="inline-flex items-center gap-1.5">
                Read Case
                <ArrowUpRight className="h-3.5 w-3.5" />
              </span>
            </Button>
          </div>
        </div>
      </div>
    </CardWrapper>;
}
function ProjectsGallery() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
        {spanClasses.map((span, i) => <div key={i} data-index={i} className={`rounded-lg bg-muted/40 animate-pulse ${span}`} />)}
      </div>;
  }
  const sourceProjects = !error && posts && posts.length > 0 ? posts.slice(0, 12).map((post, i) => {
    const fallback = fallbackProjects[i];
    return {
      id: post.id,
      title: post.title || fallback.title,
      category: post.categories && post.categories[0]?.name || fallback.category,
      image: post.featuredImage || fallback.image,
      srcset: post.featuredImage ? undefined : fallback.srcset,
      sizes: post.featuredImage ? undefined : fallback.sizes,
      link: post.link || "#"
    };
  }) : fallbackProjects.map(p => ({
    id: p.id,
    title: p.title,
    category: p.category,
    image: p.image,
    srcset: p.srcset,
    sizes: p.sizes,
    link: "/CaseStudiesPage"
  }));
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
      {sourceProjects.map((project, i) => <ProjectCard key={project.id} index={i} title={project.title} category={project.category} image={project.image} srcset={project.srcset} sizes={project.sizes} link={project.link} spanClass={spanClasses[i] || spanClasses[i % spanClasses.length]} />)}
    </div>;
}
export default function Casestudyshowcase() {
  const wp_query_params = {
    post_type: "project",
    per_page: 12,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="30585" id="casestudyshowcase" className="bg-background text-foreground">
      <div className="mx-auto w-full max-w-[1440px] px-6 py-40 sm:px-10 md:py-56 lg:px-24">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-2">
            <span className="block text-[14px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
              Case Studies
            </span>
          </div>

          <div className="md:col-span-10">
            <h2 className="font-serif text-2xl leading-[0.96] tracking-tight text-foreground sm:text-3xl lg:text-4xl">
              Proven results.{" "}
              <span className="italic font-normal">Real</span>{" "}
              <span className="relative inline-block">
                <span className="relative z-10">growth</span>
                <svg aria-hidden="true" viewBox="0 0 300 30" preserveAspectRatio="none" className="pointer-events-none absolute inset-x-0 -bottom-2 h-[0.35em] w-full text-accent">
                  <path d="M4 18 C 40 8, 90 24, 150 14 S 260 22, 296 12" fill="none" stroke="currentColor" strokeWidth="10" strokeLinecap="round" opacity="0.95" />
                </svg>
              </span>
              <span aria-hidden="true">.</span>
            </h2>

            <p className="mt-8 max-w-2xl font-default text-base leading-relaxed text-muted-foreground md:text-lg">
              Explore my verified SEO case studies. Each project follows a 
              rigorous Challenge-Strategy-Implementation-Results framework 
              to deliver sustainable search growth for my clients.
            </p>
          </div>
        </div>

        <div className="mt-20 md:mt-24">
          <PostsProvider wp_query={{
          post_type: "project",
          per_page: 12,
          order: "desc",
          orderby: "date",
          status: ["publish"]
        }}>
            <ProjectsGallery />
          </PostsProvider>
        </div>
      </div>
    </section>;
}